import BackendClient from '../backend-client';
import Announcement, { modelFactory } from './model';

export default class AnnouncementsClient extends BackendClient {
  constructor(options = {}) {
    super(modelFactory, options);
    this.$path = `/public/${ modelFactory.ns}`;
  }

  list = (start, size, filters = {}, sort) => {
    const WC = {};

    if (typeof filters.location === 'number') {
      WC.location = filters.location;
    }

    return this.req(WC, {
      start,
      size,
      sort,
    });
  }
}

export {
  Announcement,
};
